import { ThemeEvents } from '@theme/events';

// Size option values, ordered from smallest to largest by price tier (matches this store's
// size pricing: S < M < L < XL). Index in this array = size rank used for gallery positioning.
const SIZE_ORDER = [
  '12in x 8in, 30.5cm x 20.3cm',
  '24in x 16in, 61cm x 40.6cm',
  '50in x 33.3in, 127cm x 84.6cm',
  '36in x 24in, 91.4cm x 61cm',
];

function rankOf(value) {
  const idx = SIZE_ORDER.indexOf(value);
  return idx === -1 ? 0 : idx;
}

/**
 * @param {HTMLElement} container
 * @param {[string|undefined, string|undefined, string|undefined]} values
 */
function applyOrder(container, values) {
  let media;
  try {
    media = JSON.parse(container.dataset.media || '[]');
  } catch (error) {
    return;
  }
  if (!Array.isArray(media) || media.length !== 3) return;

  const items = media.map((m, index) => ({ media: m, rank: rankOf(values[index]), index }));

  items.sort((a, b) => {
    if (b.rank !== a.rank) return b.rank - a.rank;
    return a.index - b.index;
  });

  const [large, medium, small] = items;
  const largeImg = container.querySelector('[data-slot="large"] img');
  const mediumImg = container.querySelector('[data-slot="medium"] img');
  const smallImg = container.querySelector('[data-slot="small"] img');

  if (largeImg && large) {
    largeImg.src = large.media.src;
    largeImg.alt = large.media.alt || '';
  }
  if (mediumImg && medium) {
    mediumImg.src = medium.media.src;
    mediumImg.alt = medium.media.alt || '';
  }
  if (smallImg && small) {
    smallImg.src = small.media.src;
    smallImg.alt = small.media.alt || '';
  }
}

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const detail = /** @type {any} */ (event).detail;
  const resource = detail && detail.resource;
  const data = detail && detail.data;
  if (!resource || !data || !data.productId) return;

  const containers = document.querySelectorAll(
    `.print-set-gallery[data-product-id="${data.productId}"]`
  );
  if (!containers.length) return;

  const values = [resource.option1, resource.option2, resource.option3];
  containers.forEach((container) => applyOrder(/** @type {HTMLElement} */ (container), values));
});
